/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Constants for Locations
 */

const LOCATION_STATUS = {
	active: {
		title: 'Enabled',
		value: true,
		fhirValue: 'active' as Location.Status,
		color: 'green',
	},
	inactive: {
		title: 'Disabled',
		value: false,
		color: 'red',
		fhirValue: 'inactive' as Location.Status,
	},
};

const LOCATION_SEARCH_FIELDS = {
	name: {
		key: 'name', // TODO: add type for key,
		label: 'Location Name',
		placeHolder: 'Please enter at least 3 characters',
	},
};

export { LOCATION_STATUS, LOCATION_SEARCH_FIELDS };
